import PropTypes from "prop-types"
import classnames from "classnames"

import FilterIcon from "shared/components/icons/filter_icon"
import { verifyIntendedPromiseRejection } from "./utils/modal_promise"
import { cancellationError } from "./utils/error_map"

import "./diy_tanda_selected.scss"
import DelayIcon from "shared/components/icons/delay_icon"

export default function DIYTandaSelected({
  canEdit,
  label,
  onDeleteClick,
  onEditClick,
  liveChannelId,
  service: {
    brand_color,
    image,
    name,
    live_channels,
    allow_multiple_live_channels,
  },
  showProFeatures,
  stepName,
}) {
  const isFilter = label === "when"
  const isDelay = label === "wait"

  const serviceImage = () => {
    if (isFilter) {
      return <FilterIcon />
    } else if (isDelay) {
      return <DelayIcon />
    } else {
      return (
        <img
          width="20"
          height="20"
          src={image}
          alt={`${name} icon`}
          title={name}
        />
      )
    }
  }

  const blockClass = classnames("tanda-selected-block", {
    highlighted: ["if", "then"].includes(label),
    clickable: canEdit || isFilter,
  })
  const blockStyle = { borderColor: brand_color, backgroundColor: brand_color }
  const labelClass = classnames("label", {
    when: isFilter || isDelay,
  })

  const dataConfirmation = () => {
    let message
    if (label === "if") {
      message = showProFeatures
        ? "If you’ve used any of this trigger’s ingredients in queries, filter code or actions you will have to remove those ingredients before saving this Applet."
        : "If you’ve used any of this trigger’s ingredients in your action you will have to remove those ingredients before saving this Applet."
    } else if (label === "with") {
      message =
        "If you’ve used any of this query’s ingredients in filter code or actions you will have to remove those ingredients before saving this Applet."
    } else if (showProFeatures && ["then", "and"].includes(label)) {
      message =
        "If you’ve used this action in filter code you will have to remove this code before saving this Applet."
    }

    return new Promise((resolve, reject) => {
      if (message && !window.confirm(message)) {
        reject(cancellationError)
      } else {
        resolve()
      }
    })
  }

  const wrapHandler = handler => {
    return e => {
      e.stopPropagation()
      verifyIntendedPromiseRejection(handler())
    }
  }

  const selectedLiveChannel = live_channels?.find(lc => lc.id == liveChannelId)

  return (
    <section
      onClick={canEdit || isFilter ? wrapHandler(onEditClick) : undefined}
      style={blockStyle}
      styleName={blockClass}
    >
      <span styleName={labelClass}>{label}</span>

      {serviceImage()}
      <div styleName="step">
        <span styleName={classnames("step-name", { then: label === "then" })}>
          {stepName}
        </span>
        {allow_multiple_live_channels && (
          <span styleName="step-multi-account-selected">
            {selectedLiveChannel?.user_name_field}
          </span>
        )}
      </div>

      <div styleName="actions">
        {(canEdit || isFilter) && (
          <button styleName="action" onClick={wrapHandler(onEditClick)}>
            Edit
          </button>
        )}
        <button
          styleName="action"
          onClick={wrapHandler(() => onDeleteClick(dataConfirmation))}
        >
          Delete
        </button>
      </div>
    </section>
  )
}

DIYTandaSelected.propTypes = {
  canEdit: PropTypes.bool,
  color: PropTypes.string,
  showProFeatures: PropTypes.bool,
  label: PropTypes.oneOf(["if", "with", "when", "wait", "then", "and"]),
  onDeleteClick: PropTypes.func.isRequired,
  onEditClick: PropTypes.func,
  liveChannelId: PropTypes.string,
  service: PropTypes.shape({
    image: PropTypes.string.isRequired,
    brand_color: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    live_channels: PropTypes.array,
    allow_multiple_live_channels: PropTypes.bool,
  }).isRequired,
  stepName: PropTypes.string.isRequired,
}

DIYTandaSelected.defaultProps = {
  showProFeatures: false,
}
